module.exports = __webpack_public_path__ + "img/Vue-FransHals-desktop.22e3166a.png";